export default function CoverageCalc() {
    coverage();
    backToCalc();
}

const widthInput = document.getElementById('width'),
      heightInput = document.getElementById('height'),
      submit = document.querySelector('.coverage'),
      calculator = document.querySelector('.js-calculator-form'),
      results = document.querySelector('.calculator-results'),
      resultOutput = document.querySelector('.calc-results'),
      backButton = document.querySelector('.back-to-calc'),
      resultsWrapper = document.querySelector('.calc-results-wrapper');


function coverage() {

    if (submit) {
        submit.addEventListener("click", function (event) {
            event.preventDefault();

            const coverage = this.getAttribute('data-coverage');

            const width = widthInput.value,
                height = heightInput.value,
                coverageResult = ((width * height) / coverage).toFixed(1);

            calculator.classList.add('hidden');
            results.classList.remove('hidden');

            if ( coverageResult.length > 7 )
            {
                resultsWrapper.classList.add('smaller-font');
            } else {
                resultsWrapper.classList.remove('smaller-font');
            }

            resultOutput.innerHTML = parseFloat(coverageResult);
        });
    }
}

function backToCalc() {

    if (backButton) {
        backButton.addEventListener("click", function () {
            calculator.classList.remove('hidden');
            results.classList.add('hidden');
        });
    }
}

